import script from "./SignatureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureCard.vue?vue&type=script&setup=true&lang=js"

import "./SignatureCard.vue?vue&type=style&index=0&id=11332ff6&scoped=true&lang=css"

import exportComponent from "/home/forge/driver.blackwidow.org.za/releases/80919820/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11332ff6"]])

export default __exports__